import React,{ useEffect, useRef, useState } from 'react';

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { withRouter, Link } from "react-router-dom";

//redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/store/reducers";
import { logout } from "src/store/Authentication/authActions";
import { removeAuthUser } from "../../../../services/Authentication/AuthenticationService"
import { AuthAPIService } from "src/api/Authentication/API_AuthService";
import { removeStoreXUser } from 'src/services/Stores/FilteredStoreService';
import { RevokeIsOpenForCurrentUser } from 'src/services/General/GenericService';
import { AccountingEndpoints, ProductsEndpoints } from 'src/constants/apiEndpoints';
import profile_icon from "../../../../assets/icons/profile_icon.png";

const DropdownProfile = () => {

    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.auth.user?.username);
    const [loading, setLoading] = useState<boolean>(false);

    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            setLoading(null as any);
            isMountedRef.current = false;
        };
    }, []);

    const logoutUser = async () => {
        setLoading(true);
        // Quitar los archivos que esten marcados como activos por el usuario
        await RevokeIsOpenForCurrentUser(ProductsEndpoints.purchaseRequest);

        AuthAPIService.logout().finally(() => {
            if (isMountedRef.current) {
                setLoading(false);
                sessionStorage.removeItem('purchaseRequestId');
                sessionStorage.removeItem('invoicesListPage');
                sessionStorage.removeItem('quotationId');
                sessionStorage.removeItem('bankId');
                sessionStorage.removeItem('itemCode');
                sessionStorage.removeItem('invoice_client');
                dispatch(logout());
                removeAuthUser();
                removeStoreXUser();
            }
        });
    };

    return (
        <div className="navbar-item navbar-user dropdown">
            <a href="#" className="navbar-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
                <span>
                    <span className="d-none d-md-inline">{ user }</span>
                    <b className="caret"></b>
                </span>
                <div className="image image-icon">
                    {/* <i className="fa fa-user"></i> */}
                    <img src={profile_icon } alt={"profile icon"} />
                </div>
            </a>
            <div className="dropdown-menu dropdown-menu-end me-1">
                <div className="dropdown-divider"></div>

                {!loading ? (
                    <Link onClick={logoutUser} to="#" className="dropdown-item">
                        <i className="fa fa-power-off me-1 text-danger" />
                        <span>Cerrar Sesión</span>
                    </Link>
                ) : (
                    <Link onClick={() => {}} to="#" className="dropdown-item">
                        <i className="fa fa-hourglass fa-spin me-1 text-danger" />
                        <span>Saliendo...</span>
                    </Link>
                )}
            </div>
        </div>
    );
}

// export default DropdownProfile;
export default withTranslation()(withRouter(DropdownProfile));